import React from "react";
import { bool, string } from "prop-types";

import * as S from "./styled";

const MainNavigation = ({
  isBuildingSRP,
  isExpandedAreaSection,
  isHomePage,
  nearMeListingType,
  rootZendeskUrl,
  userIsRMC
}) => (
  <S.Wrapper
    isExpandedAreaSection={isExpandedAreaSection}
    userIsRMC={userIsRMC}
  >
    <S.LinksList>
      <S.ListItem>
        <S.Link href="/blog/">Blog</S.Link>
      </S.ListItem>
      <S.ListItem>
        <S.Link href="https://www.zillow.com/careers/">
          We&apos;re hiring!
        </S.Link>
      </S.ListItem>
    </S.LinksList>
    <S.LinksList>
      <S.ListItem isMWebHidden>
        <S.Link href="/nyc/submit_your_listings?lct=footer&prd=submit_your_listing">
          Submit your listings
        </S.Link>
      </S.ListItem>
      <S.ListItem>
        <S.Link href="https://streeteasy.com/business/">Work with us</S.Link>
      </S.ListItem>
      <S.ListItem>
        <S.Link href="/nycrentalnetwork">NYC rental network</S.Link>
      </S.ListItem>
      <S.ListItem isMWebHidden>
        <S.Link
          href="https://streeteasy.com/blog/press-room/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Press room
        </S.Link>
      </S.ListItem>
    </S.LinksList>
    <S.LinksList>
      <S.ListItem>
        <S.Link href="/browse/">Browse all homes</S.Link>
      </S.ListItem>
      <S.ListItem>
        <S.Link href={`/apartments-for-${nearMeListingType}-near-me/`}>
          Near Me
        </S.Link>
      </S.ListItem>
    </S.LinksList>
    <S.LinksList>
      {isHomePage && (
        <S.ListItem isHiddenDesktop>
          <S.Link href="/sales/all" isSubLink>
            View All Sales
          </S.Link>
        </S.ListItem>
      )}
      {isBuildingSRP && (
        <S.ListItem isHiddenDesktop>
          <S.Link href="/buildings/all" isSubLink>
            View All Buildings
          </S.Link>
        </S.ListItem>
      )}
      {!userIsRMC && (
        <S.ListItem>
          <S.Link
            href={rootZendeskUrl}
            isSubLink
            rel="noopener noreferrer"
            target="_blank"
          >
            Help
          </S.Link>
        </S.ListItem>
      )}
      <S.ListItem>
        <S.Link href="https://www.zillow.com/corp/Terms.htm" isSubLink>
          Terms of Use & Privacy Policy
        </S.Link>
      </S.ListItem>
      <S.ListItem isMWebHidden>
        <S.Link
          href="https://www.zillow.com/corp/Privacy.htm#behavioralAdvertising"
          isSubLink
        >
          Ad Choice
        </S.Link>
      </S.ListItem>
    </S.LinksList>
    {isHomePage && (
      <S.LinksList isMWebHidden>
        <S.ListItem>
          <S.Link href="https://outeast.com/" isSubLink>
            The Hamptons Site
          </S.Link>
        </S.ListItem>
      </S.LinksList>
    )}
  </S.Wrapper>
);

MainNavigation.propTypes = {
  isBuildingSRP: bool.isRequired,
  isExpandedAreaSection: bool.isRequired,
  isHomePage: bool.isRequired,
  nearMeListingType: string.isRequired,
  rootZendeskUrl: string.isRequired,
  userIsRMC: bool.isRequired
};

export default MainNavigation;
